import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface NudgePayload {
  webinar_id: string;
  occurence_id?: string;
  meeting_role?: string;
  class_type?: string;
}

export default function useNudgeApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, NudgePayload> {
  return useMutation<any, unknown, NudgePayload>(
    async (payload: NudgePayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/classroom_nudge/',
        payload,
      );
      console.log('Classroom nudge = ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to add Classroom nudge:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
